(function () {
  "use strict";

  // Guard against the script being included more than once on a page.
  if (window.__bridgmanHashLinksInit) return;
  window.__bridgmanHashLinksInit = true;

  const HEADER_SELECTOR = ".bridgman-header";
  const EXTRA_OFFSET = 16; // breathing room between the header and the target
  const FALLBACK_OFFSET = 100; // used if the header can't be measured
  const SCROLL_BEHAVIOR = window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
  const LOAD_SCROLL_DELAY_MS = 100;

  function getHeaderOffset() {
    const header = document.querySelector(HEADER_SELECTOR);
    if (!header) return FALLBACK_OFFSET;

    const position = window.getComputedStyle(header).position;
    // A non-sticky header scrolls away with the page, so it never covers the target.
    if (position !== "sticky" && position !== "fixed") return EXTRA_OFFSET;

    return header.getBoundingClientRect().height + EXTRA_OFFSET;
  }

  function getTargetElement(hash) {
    if (!hash || hash === "#") return null;

    const id = decodeURIComponent(hash.slice(1));
    return (
      document.getElementById(id) ||
      document.querySelector(`[name="${CSS.escape(id)}"]`)
    );
  }

  function scrollToTarget(hash, updateHistory = true) {
    const target = getTargetElement(hash);
    if (!target) return false;

    const targetRect = target.getBoundingClientRect();
    const targetY = window.pageYOffset + targetRect.top - getHeaderOffset();

    window.scrollTo({
      top: Math.max(0, targetY),
      behavior: SCROLL_BEHAVIOR,
    });

    if (updateHistory) {
      history.pushState(null, "", hash);
    }

    return true;
  }

  function isSamePageHashLink(link) {
    if (!link || !link.hash) return false;

    const url = new URL(link.href, window.location.href);
    return (
      url.pathname === window.location.pathname &&
      url.search === window.location.search &&
      url.hash
    );
  }

  document.addEventListener("click", function (event) {
    const link = event.target.closest('a[href*="#"]');
    if (!link || !isSamePageHashLink(link)) return;
    // Leave lightbox and other script-driven links alone.
    if (link.hasAttribute("data-fancybox") || link.hasAttribute("data-no-smooth-scroll")) return;

    const target = getTargetElement(link.hash);
    if (!target) return;

    event.preventDefault();
    scrollToTarget(link.hash, true);
  });

  window.addEventListener("load", function () {
    if (window.location.hash) {
      // Small delay lets lazy images and sliders settle before measuring
      setTimeout(function () {
        scrollToTarget(window.location.hash, false);
      }, LOAD_SCROLL_DELAY_MS);
    }
  });

  window.addEventListener("hashchange", function () {
    if (window.location.hash) {
      scrollToTarget(window.location.hash, false);
    }
  });

  window.BridgmanHashLinks = { scrollToTarget: scrollToTarget };
})();
